import createMemberSubmission from "./createMemberSubmission";

const memberSubmissionWebsiteServices = {
  createMemberSubmission,
};

export default memberSubmissionWebsiteServices;
